import { render, staticRenderFns } from "./TDsupport.vue?vue&type=template&id=458a877c&scoped=true"
import script from "./TDsupport.vue?vue&type=script&lang=js"
export * from "./TDsupport.vue?vue&type=script&lang=js"
import style0 from "./TDsupport.vue?vue&type=style&index=0&id=458a877c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a877c",
  null
  
)

export default component.exports